import type { DTADetails } from "../../../services/dtaApi"

/**
 * An internal caller may edit a DTA only while it is in DRAFT, unlocked, and not mid-extraction.
 * Mirrors the backend rule (update_dta_handler rejects any edit outside DRAFT).
 */
export const canEditDta = (stream: DTADetails, isDAE: boolean): boolean => {
  if (stream.extraction_status === "IN_PROGRESS") return false
  return isDAE && stream.workflow_stage === "DRAFT" && !stream.locked
}
